import * as React from "react";
import { cn } from "@/lib/utils";

interface BadgeStalenessProps extends React.HTMLAttributes<HTMLDivElement> {
  days: number;
}

export function BadgeStaleness({ days, className, ...props }: BadgeStalenessProps) {
  const getVariant = () => {
    if (days <= 30) {
      return "border border-border text-foreground bg-background";
    } else if (days <= 90) {
      return "bg-warning/10 text-warning border border-warning/20";
    } else {
      return "bg-destructive/10 text-destructive border border-destructive/20";
    }
  };

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-colors",
        getVariant(),
        className
      )}
      {...props}
    >
      {days}d stale
    </div>
  );
}
